"use strict";

var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ServerController = _interopRequireDefault(require("./ServerController"));
var _ClientController = _interopRequireDefault(require("./ClientController"));
var _Actions = require("./state/Actions");
var _ContextProvider = require("./ContextProvider");
var _Reducer = _interopRequireDefault(require("./state/Reducer"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var PaginatedTable = function PaginatedTable(_ref) {
  var _ref$queryVariables = _ref.queryVariables,
    queryVariables = _ref$queryVariables === void 0 ? {} : _ref$queryVariables,
    _ref$themeConfig = _ref.themeConfig,
    themeConfig = _ref$themeConfig === void 0 ? {} : _ref$themeConfig,
    _ref$totalRowCount = _ref.totalRowCount,
    totalRowCount = _ref$totalRowCount === void 0 ? 0 : _ref$totalRowCount,
    initState = _ref.initState,
    _ref$activeTab = _ref.activeTab,
    activeTab = _ref$activeTab === void 0 ? true : _ref$activeTab,
    _ref$server = _ref.server,
    server = _ref$server === void 0 ? true : _ref$server,
    _ref$tblRows = _ref.tblRows,
    tblRows = _ref$tblRows === void 0 ? [] : _ref$tblRows;
  /**
  * Initailize useReducer state
  * 1. table: state (Note: table includes cofiguration in addition to pagination state)
  * 2. dispatch: dispatch action (as redux action) to update pagination state
  * 3. Add all btn / Add file button also dispatch action to update table state
  */
  var _ref2 = (0, _react.useReducer)(_Reducer.default, {}, initState),
    _ref3 = _slicedToArray(_ref2, 2),
    table = _ref3[0],
    dispatch = _ref3[1];
  /**
  * use context to provide table state to wrapper component
  */
  var tableContext = (0, _react.useContext)(_ContextProvider.TableContext);
  (0, _react.useEffect)(function () {
    /**
    * set table context
    * 1. provide table state to other component (wrapper comp -> Add file button)
    * 2. provide table dispatch action to other component (wrapper comp)
    */
    var setContext = tableContext.setContext;
    setContext(_objectSpread(_objectSpread({}, table), {}, {
      dispatch: dispatch
    }));
  }, [table]);

  /**
  * update state to props change
  */
  (0, _react.useEffect)(function () {
    var page = table.page,
      rowsPerPage = table.rowsPerPage; // validate table state - curr rowCount should be less than total row count after filter
    // above validation steps when page is zero
    // prevent currentRows denominator to be zero (newPage -> Nan)
    if (page > 0 && totalRowCount <= page * rowsPerPage) {
      var adjustRow = page === 1 ? 1 : 0;
      var currentRows = page * rowsPerPage + adjustRow;
      var newPage = Math.floor(totalRowCount / currentRows);
      dispatch((0, _Actions.onPageAndTotalCountChange)({
        page: newPage,
        totalRowCount: totalRowCount
      }));
    } else {
      dispatch((0, _Actions.setTotalRowCount)(totalRowCount));
    }
  }, [totalRowCount]);
  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    var noOfRows = parseInt(event.target.value, 10);
    dispatch((0, _Actions.onRowsPerPageChange)({
      rowsPerPage: noOfRows,
      page: 0
    }));
  };
  var handleChangePage = function handleChangePage(event, newPage) {
    dispatch((0, _Actions.onPageChange)({
      pageNumb: newPage
    }));
  };

  /**
  * update selected Ids
  * @param {*} event
  * @param {*} row
  */
  var onRowSelectHandler = function onRowSelectHandler(event, row) {
    event.stopPropagation();
    var selectedIds = _toConsumableArray(table.selectedRows);
    var selectedId = row[table.dataKey];
    if (!row.isChecked) {
      selectedIds.push(selectedId);
    } else {
      selectedIds = selectedIds.reduce(function (acc, id) {
        if (selectedId !== id) {
          acc.push(id);
        }
        return acc;
      }, []);
    }
    dispatch((0, _Actions.onRowSeclect)(selectedIds));
  };
  var handleToggleSelectAll = function handleToggleSelectAll(event, Ids, includeIds) {
    if (event.target.checked && !includeIds) {
      var selecedIds = Ids.concat(table.selectedRows);
      dispatch((0, _Actions.onRowSeclect)(selecedIds));
    } else {
      var filterIds = table.selectedRows.filter(function (id) {
        return !Ids.includes(id);
      });
      dispatch((0, _Actions.onRowSeclect)(filterIds));
    }
  };
  var handleSortByColumn = function handleSortByColumn(column, order) {
    var sortBy = table.sortBy;
    var sort = order === 'asc' && sortBy === column ? 'desc' : 'asc';
    dispatch((0, _Actions.onColumnSort)({
      sort: sort,
      column: column
    }));
  };

  /**
  * manage columns view change
  * hide/display columns from table
  */
  var handleColumnViewChange = function handleColumnViewChange(column) {
    var columns = table.columns.map(function (col) {
      var updateColumnView = _objectSpread({}, col);
      if (col.dataField === column.dataField) {
        updateColumnView.display = !column.display;
      }
      return updateColumnView;
    });
    dispatch((0, _Actions.onColumnViewChange)(_objectSpread(_objectSpread({}, table), {}, {
      columns: columns
    })));
  };
  /**
  * A. client table
  * table data provide by bento app (tblRows)
  * Rows display & column sorting by ClientController
  */
  if (!server) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ClientController.default, {
      tblRows: tblRows,
      table: table,
      onRowsPerPageChange: handleChangeRowsPerPage,
      onPageChange: handleChangePage,
      onRowSelectChange: onRowSelectHandler,
      onToggleSelectAll: handleToggleSelectAll,
      onSortByColumn: handleSortByColumn,
      onColumnViewChange: handleColumnViewChange,
      themeConfig: themeConfig
    }));
  }

  /**
  * B. server table
  * bento-core makes http call base on table state
  */
  /**
  * prevent loading data except for active tab
  */
  if (!activeTab) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ServerController.default, {
    queryVariables: queryVariables,
    totalRowCount: totalRowCount,
    table: table,
    onRowsPerPageChange: handleChangeRowsPerPage,
    onPageChange: handleChangePage,
    onRowSelectChange: onRowSelectHandler,
    onToggleSelectAll: handleToggleSelectAll,
    onSortByColumn: handleSortByColumn,
    onColumnViewChange: handleColumnViewChange,
    themeConfig: themeConfig
  }));
};
var _default = PaginatedTable;
exports.default = _default;